import { createFileRoute } from "@tanstack/react-router"

import { CleanupOverviewPanel } from "@/pages/CleanupOverviewPanel"

export const Route = createFileRoute("/administration/cleanup-overview")({
  component: CleanupOverviewPanel,
})
